import PropTypes from 'prop-types';
import ImageBanner from 'components/ImageBanner';
import breakPoints from 'helpers/Styles';

const PageHeader = ({ bannerImage, bannerImageMobile, title, description }) => (
  <>
    <ImageBanner
      bannerImage={bannerImage}
      bannerImageMobile={bannerImageMobile}
    />
    <div className="wrapper">
      <div className="header">
        <div>
          <h1 className="heading">{title}</h1>
        </div>
        <div className="description">{description}</div>
      </div>
    </div>
    <style jsx>
      {`
        .header {
          padding: 50px 100px;
        }
        .heading {
          color: #e4e4e4;
          font-family: 'big_noodle_titling';
          font-size: 39px;
          letter-spacing: 0;
          line-height: 48px;
          text-align: center;
        }
        .description {
          width: 656px;
          margin-left: auto;
          margin-right: auto;
          color: #e4e4e4;
          font-family: 'Roboto-Light';
          font-size: 16px;
          letter-spacing: 0;
          line-height: 24px;
          text-align: center;
        }
        @media (max-width: ${breakPoints.small}) {
          .description {
            margin-left: auto;
            margin-right: auto;
            color: #e4e4e4;
            font-family: 'Roboto-Light';
            font-size: 16px;
            letter-spacing: 0;
            line-height: 24px;
            text-align: center;
          }
        }
        @media (max-width: ${breakPoints.medium}) {
          .description {
            width: unset;
          }
        }
        @media (max-width: ${breakPoints.small}) {
          .header {
            background-color: #000000;
            padding: 50px 50px;
          }
        }
      `}
    </style>
  </>
);

PageHeader.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  bannerImage: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  bannerImageMobile: PropTypes.object,
  title: PropTypes.string,
  description: PropTypes.string,
};

PageHeader.defaultProps = {
  bannerImage: null,
  bannerImageMobile: null,
  title: null,
  description: null,
};

export default PageHeader;
